module.exports = "/static/media/article03.1b066b22.jpg";